var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['underscore', 'jquery', 'core', 'model/base'], function(_, $, core, BaseModel) {
  var NoteModel;
  return NoteModel = (function(_super) {

    __extends(NoteModel, _super);

    function NoteModel() {
      NoteModel.__super__.constructor.apply(this, arguments);
    }

    NoteModel.prototype.defaults = function() {
      return {
        userId: 0,
        body: '',
        timestamp: parseInt(Date.now() / 1000),
        flagged: false,
        userFirstName: null,
        userLastName: null
      };
    };

    NoteModel.prototype.getPersonModel = function() {
      var _ref;
      return (_ref = this.collection.personCollection) != null ? _ref.get(this.get('userId')) : void 0;
    };

    return NoteModel;

  })(BaseModel);
});
